import BaseModel from "./base-model";

export const USER_NAME_CHAINLOGIS = "chainlogis";
export const USER_NAME_CHAINLOGISAPITEST = "chainlogisapitest";
export const USER_NAME_SK7MOBILE = "sk7mobile";
export const USER_NAME_SKTELECOM = "sktelecom";
export const USER_NAME_SKTMVNO = "sktmvno";
export const USER_NAME_LGHELLOVISION = "lghellovision";
export const USER_NAME_LGHELLOVISION_ADM = "lghellovisionadm";
export const USER_NAME_OURBOX_ADM = "ourboxadm";
export const USER_NAME_ZION_USIM = "zion_usim";
export const USER_NAME_DRX = "drx";
export const USER_NAME_HANJINAPI = "hanjinapi";
export const USER_NAME_HANJINDOMESTIC = "hanjindomestic";
export const USER_NAME_THEROOTS3 = "theroots3";
export const USER_NAME_CJOY_QUICK_API = "cjoyquickapi";
export const USER_NAME_CJOY_QUICK_ADM = "cjoyquickadm";
export const USER_NAME_KB9597 = "kb9597"; // 국민은행
export const USER_NAME_WOORIWON = "wooriwon"; // 우리은행
export const USER_NAME_GSSHOP_ADM = "gsshop_adm";
export const USER_NAME_AMORE_ADM = "amore_adm";
export const USER_NAME_HARIM_ADM = "harim_adm";
export const USER_NAME_HANJIND_ADM = "hanjind_adm";

const HANJIN_CS_USERNAMES = new Set([
  USER_NAME_GSSHOP_ADM,
  USER_NAME_AMORE_ADM,
  USER_NAME_HARIM_ADM,
  USER_NAME_HANJIND_ADM,
  USER_NAME_HANJINDOMESTIC,
]);

const CS_COMMUNICATION_USERNAMES = new Set([
  ...HANJIN_CS_USERNAMES,
  USER_NAME_CHAINLOGISAPITEST,
  USER_NAME_LGHELLOVISION_ADM,
  USER_NAME_OURBOX_ADM,
]);

export default class User extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  get displayDestinationAddress() {
    if (this.etcObj) {
      return this.etcObj.displayDestinationAddress || false;
    }
    return this.userEtcObj?.displayDestinationAddress || false;
  }

  get editableByWorksheet() {
    return !!this.userEtcObj?.editableByWorksheet || false;
  }

  get userEtcObj() {
    try {
      return this.etc && JSON.parse(this.etc);
    } catch (e) {
      return {};
    }
  }

  get isDrx() {
    return this.username === USER_NAME_DRX;
  }

  get isHanjinapi() {
    return this.username === USER_NAME_HANJINAPI;
  }

  get isHanjindomestic() {
    return (
      this.username === USER_NAME_HANJINDOMESTIC ||
      this.username === USER_NAME_CHAINLOGISAPITEST
    );
  }

  get isCjoyQuick() {
    return (
      this.username === USER_NAME_CJOY_QUICK_API ||
      this.username === USER_NAME_CJOY_QUICK_ADM
    );
  }

  get isChainlogisApiTest() {
    return this.username === USER_NAME_CHAINLOGISAPITEST;
  }

  get isSk() {
    return (
      this.username === USER_NAME_SK7MOBILE ||
      this.username === USER_NAME_SKTELECOM ||
      this.username === USER_NAME_SKTMVNO
    );
  }

  get isLgHelloVision() {
    return this.username === USER_NAME_LGHELLOVISION;
  }

  get isZionUsim() {
    return this.username === USER_NAME_ZION_USIM;
  }

  get isValidateForUpdate() {
    return (
      this.isSk ||
      this.isLgHelloVision ||
      this.isZionUsim ||
      this.isChainlogisApiTest // 확인용
    );
  }

  get showDownloadButton() {
    return (
      this.username !== USER_NAME_KB9597 && this.username !== USER_NAME_WOORIWON
    );
  }

  get useMasking() {
    return !!this.userEtcObj?.useMasking || false;
  }

  get senderNames() {
    return this.userEtcObj?.senderNames || [];
  }

  get showRequestedDeliveryTime() {
    if (this.etcObj) {
      return this.etcObj.showRequestedDeliveryTime || false;
    }

    return this.userEtcObj?.showRequestedDeliveryTime || false;
  }

  get spotName() {
    return this.spots.length ? this.spots[0].name : "";
  }

  get spotCode() {
    return this.spots.length ? this.spots[0].code : "";
  }

  get spotAddress() {
    return this.spots.length ? this.spots[0].address : "";
  }

  get spotAddressDetail() {
    return this.spots.length ? this.spots[0].addressDetail : "";
  }

  get spotAddressExcelSchemeObj() {
    return this.spots.length ? this.spots[0].excelSchemeObj : null;
  }
  get spotAddressExcelScheme() {
    return this.spots.length ? this.spots[0].excelScheme : "";
  }

  get spotAddressExcelSchemeParsed() {
    try {
      return (
        this.spotAddressExcelSchemeObj ||
        (this.spotAddressExcelScheme && JSON.parse(this.spotAddressExcelScheme))
      );
    } catch (e) {
      return {};
    }
  }

  get updatable() {
    return (
      this.username === USER_NAME_CHAINLOGIS ||
      this.username === USER_NAME_CHAINLOGISAPITEST ||
      this.username === USER_NAME_SK7MOBILE ||
      this.username === USER_NAME_LGHELLOVISION ||
      this.username === USER_NAME_ZION_USIM ||
      this.username === USER_NAME_DRX ||
      this.username === USER_NAME_THEROOTS3
    );
  }

  get canAccessCsCommunication() {
    return CS_COMMUNICATION_USERNAMES.has(this.username);
  }

  get canUseHanjinCsApproval() {
    return HANJIN_CS_USERNAMES.has(this.username);
  }

  get canSelectHanjinWaybill() {
    return HANJIN_CS_USERNAMES.has(this.username);
  }
}
